import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import TableStyle from '../../ui-component/TableStyle';
import { useState } from 'react';
import { Stack, Button, Container, Typography, Box, Card } from '@mui/material';
import * as React from 'react';
import { useEffect } from 'react';
import { getApi } from 'views/services/api';
import moment from 'moment';
// ----------------------------------------------------------------------

const AdminPayments = () => {
  const navigate = useNavigate();
  const [paymentData, setpaymentData] = useState([]);

  // function for fetching all the hotels data from the db

  const fetchpaymentData = async () => {
    try {
      const response = await getApi(`api/payments/totalPayment`);
      setpaymentData(response?.data?.paymentsData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchpaymentData();
  }, []);

  const columns = [
    {
      field: 'hotelName',
      headerName: 'Hotel Name',
      flex: 1,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        return (
          <Box
            onClick={() => {
              navigate(`/dashboard/hotel/view/${params.row.hotelId}`);
            }}
          >
            {params.value}
          </Box>
        );
      }
    },
    {
      field: 'packageName',
      headerName: 'Package Name',
      flex: 1
    },
    {
      field: 'amount',
      headerName: 'Package Amount',
      flex: 1,
      renderCell: (params) => {
        return <Box>Rs {params.value}</Box>;
      }
    },
    {
      field: 'duration',
      headerName: 'Duration',
      flex: 1,
      renderCell: (params) => {
        return <Box>{params.value} Day(s)</Box>;
      }
    },
    {
      field: 'startDate',
      headerName: 'Start Date',
      flex: 1,
      renderCell: (params) => {
        return <Box>{moment(params?.value).format('YYYY-MM-DD ( HH:mm:ss )')}</Box>;
      }
    },
    {
      field: 'endDate',
      headerName: 'End Date',
      flex: 1,
      renderCell: (params) => {
        return <Box>{moment(params?.value).format('YYYY-MM-DD ( HH:mm:ss )')}</Box>;
      }
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: (params) => {
        let color;
        switch (params.value) {
          case 'active':
            color = 'success';
            break;
          case 'expired':
            color = 'error';
            break;
          case 'expiresSoon':
            color = 'warning';
            break;
          default:
            color = 'inherit';
            break;
        }
        return (
          <Button variant="contained" color={color}>
            {params.value}
          </Button>
        );
      }
    }
    // {
    //   field: 'status',
    //   headerName: 'Complaint Status',
    //   flex: 1,
    //   cellClassName: `name-column--cell--capitalize`,
    //   renderCell: (params) => {
    //     return params?.value === true ? (
    //       <Box sx={{ backgroundColor: '#42a142', color: 'white', padding: '10px', borderRadius: '10px' }}>Resolved</Box>
    //     ) : (
    //       <Button variant="contained" disabled>
    //         Pending
    //       </Button>
    //     );
    //   }
    // }
    // {
    //   field: 'action',
    //   headerName: 'Action',
    //   flex: 1,

    //   renderCell: (params) => {
    //     return (
    //       <Button
    //         sx={{ fontSize: '11px' }}
    //         variant="contained"
    //         startIcon={<ChangeCircleIcon icon="eva:plus-fill" />}
    //         onClick={() => handleOpenChangeStatus(params.row._id)}
    //       >
    //         Change Status
    //       </Button>
    //     );
    //   }
    // }
  ];

  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Typography variant="h4">Payments-Management</Typography>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                Payments ( {paymentData?.length} )
              </Typography>
              <DataGrid
                rows={paymentData}
                columns={columns}
                checkboxSelection
                getRowId={(row) => row?._id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{ toolbar: { showQuickFilter: true } }}
              />
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default AdminPayments;
